/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Workout_After_Stat_Sets_OfInputs */

const en_us2_workout_after_stat_sets_of = /** @type {(inputs: Workout_After_Stat_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`of ${i?.total}`)
};

const pt_br2_workout_after_stat_sets_of = /** @type {(inputs: Workout_After_Stat_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.total}`)
};

const es_419_workout_after_stat_sets_of = /** @type {(inputs: Workout_After_Stat_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.total}`)
};

const pt_pt2_workout_after_stat_sets_of = /** @type {(inputs: Workout_After_Stat_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.total}`)
};

const fr_fr2_workout_after_stat_sets_of = /** @type {(inputs: Workout_After_Stat_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sur ${i?.total}`)
};

const de_de2_workout_after_stat_sets_of = /** @type {(inputs: Workout_After_Stat_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`von ${i?.total}`)
};

const it_it2_workout_after_stat_sets_of = /** @type {(inputs: Workout_After_Stat_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "of {total}" |
*
* @param {Workout_After_Stat_Sets_OfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_stat_sets_of = /** @type {((inputs: Workout_After_Stat_Sets_OfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Stat_Sets_OfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_stat_sets_of(inputs)
	if (locale === "es-419") return es_419_workout_after_stat_sets_of(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_stat_sets_of(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_stat_sets_of(inputs)
	if (locale === "de-DE") return de_de2_workout_after_stat_sets_of(inputs)
	if (locale === "it-IT") return it_it2_workout_after_stat_sets_of(inputs)
	return en_us2_workout_after_stat_sets_of(inputs)
});
export { workout_after_stat_sets_of as "workout-after.stat_sets_of" }